import _v from './vars';
import _u from './util';

let gQlAvgVars = {};

let gQlAvgQuery = {
	
	avgLikeYou: {
	  query: `
		query FetchAvgLikeYou($homepageId: String!, $dmac: String!, $state: String!, $region: String!, $yearExp: String, $employee: String, $salaryYear: String) {
			avgLikeYou(homepageId: $homepageId, dmac: $dmac, state: $state, region: $region, yearExp: $yearExp, employee: $employee, salaryYear: $salaryYear) {
				widgetData {
				  level
				  totalCount
				  avg_salary
				  nationalPct
				  metrics
				}
			}
		}
	  `,	  
	  variables: gQlAvgVars
	},
	
	avgSalGrowth: {
	  query: `
		query FetchAvgSalaryGrowth($homepageId: String!, $dmac: String!, $state: String!, $region: String!, $yearExp: String, $employee: String, $salaryYear: String) {			
			avgSalGrowth(homepageId: $homepageId, dmac: $dmac, state: $state, region: $region, yearExp: $yearExp, employee: $employee, salaryYear: $salaryYear) {
				widgetData {
					level
					metrics
				}
			}
		}
	  `,	  
	  variables: gQlAvgVars
	},
	
	topSalarySpecialty: {
	  query: `
		query FetchTopSalarySpecialty($homepageId: String!, $dmac: String!, $state: String!, $region: String!, $yearExp: String, $employee: String, $salaryYear: String) {
			topSalarySpecialty(homepageId: $homepageId, dmac: $dmac, state: $state, region: $region, yearExp: $yearExp, employee: $employee, salaryYear: $salaryYear) {
				widgetData {
				  level
				  metrics
				}
			}
		}
	  `,	  
	  variables: gQlAvgVars
	},
	
	avgBreakDownPractice: {
	  query: `
		query FetchAvgBreakDownPractice($homepageId: String!, $dmac: String!, $state: String!, $region: String!, $yearExp: String, $employee: String, $salaryYear: String) {
			avgBreakDownPractice(homepageId: $homepageId, dmac: $dmac, state: $state, region: $region, yearExp: $yearExp, employee: $employee, salaryYear: $salaryYear) {
				widgetData {
					level
					employed {
						count
						avg_salary
					}
					selfemployed {
						count
						avg_salary
					}
				}
			}
		}
	  `,	  
	  variables: gQlAvgVars
	},
	
	topSalaryIndividuals: {
	  query: `
		query FetchTopSalaryIndividuals($homepageId: String!, $dmac: String!, $state: String!, $region: String!, $yearExp: String, $employee: String, $salaryYear: String) {
			topSalaryIndividuals(homepageId: $homepageId, dmac: $dmac, state: $state, region: $region, yearExp: $yearExp, employee: $employee, salaryYear: $salaryYear) {
				widgetData {
					level
					totalCount
					metrics
				}
			}
		}
	  `,	  
	  variables: gQlAvgVars
	},
	
	topSalaryDmac: {
	  query: `
		query FetchTopSalaryDmac($homepageId: String!, $dmac: String!, $state: String!, $region: String!, $yearExp: String, $employee: String, $salaryYear: String) {
			topSalaryDmac(homepageId: $homepageId, dmac: $dmac, state: $state, region: $region, yearExp: $yearExp, employee: $employee, salaryYear: $salaryYear) {
				widgetData {
					level
					dmacs {
						dmacName
						rank
						avg_salary
						count
						isMatchedDmac
					}
				}
			}
		}
	  `,	  
	  variables: gQlAvgVars
	},
	
	avgBreakDownGender: {
	  query: `
		query FetchBreakDownByGender($homepageId: String!, $dmac: String!, $state: String!, $region: String!, $yearExp: String, $employee: String, $salaryYear: String) {
			avgBreakDownGender(homepageId: $homepageId, dmac: $dmac, state: $state, region: $region, yearExp: $yearExp, employee: $employee, salaryYear: $salaryYear) {
				widgetData {
					level
					male {
						avg_salary
						count
					}
					female {
						avg_salary
						count
					}
				}
			}
		}
	  `,	  
	  variables: gQlAvgVars
	}
	
};

function callSalApi(query, opts) {
	
	let currQuery = gQlAvgQuery[query];
	
	Object.assign(gQlAvgVars, {
		homepageId: _v.homePageId,
		dmac: _v.userDma,
		state: _v.userState,
		region: _v.userRegion,
		yearExp: _v.userYoeRng,
		employee: _v.userEmpIdx,
		salaryYear: "2020"
	});
	
	if (typeof opts == 'object') {
		Object.assign(gQlAvgVars, opts);
	}
	
	return fetch("https://www." + _u.getDomain() + "medscape.com/api/salary/graphql", {
	   method: "POST",
	   headers: {
		"Content-Type": "application/json"
	   },
	   body: JSON.stringify(currQuery)
	})
	.then(res => {
	  return res.json();
	})
	.catch(err => {
	  console.log(err);
	});
	
}

export default callSalApi;